import { render, staticRenderFns } from "./ProjectEditTabGeneral.vue?vue&type=template&id=a096af14&"
import script from "./ProjectEditTabGeneral.vue?vue&type=script&lang=js&"
export * from "./ProjectEditTabGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports